const persianNumbersList = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbersList = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
const motions = "\u064B-\u0651"; // ً  ٌ  ٍ  َ	  ُ	  ِ	  ّ
// const motionsList2 = [/ َ/g, / ُ/g, / ِ/g, / ّ/g, /ً/g, / ٌ/g, / ٍ/g];
const motionsList = ["َ", "ُ", "ِ", "ّ", "ً", "ٌ", "ٍ"];
const arabicLetterObj = {
  ك: "ک",
  دِ: "د",
  بِ: "ب",
  زِ: "ز",
  ذِ: "ذ",
  شِ: "ش",
  سِ: "س",
  ى: "ی",
  ي: "ی",
  ء: "",
  ة: "ه",
  ئ: "ی",
  "١": "۱",
  "٢": "۲",
  "٣": "۳",
  "٤": "۴",
  "٥": "۵",
  "٦": "۶",
  "٧": "۷",
  "٨": "۸",
  "٩": "۹",
  "٠": "۰",
};
const one = [
  "",
  "یک",
  "دو",
  "سه",
  "چهار",
  "پنج",
  "شش",
  "هفت",
  "هشت",
  "نه",
  "ده",
  "یازده",
  "دوازده",
  "سیزده",
  "چهارده",
  "پانزده",
  "شانزده",
  "هفده",
  "هجده",
  "نوزده",
];
const ten = [
  "",
  "ده",
  "بیست",
  "سی",
  "چهل",
  "پنجاه",
  "شصت",
  "هفتاد",
  "هشتاد",
  "نود",
];
const hundred = [
  "",
  "صد",
  "دویست",
  "سیصد",
  "چهارصد",
  "پانصد",
  "ششصد",
  "هفتصد",
  "هشتصد",
  "نهصد",
];
const type = [
  "",
  "هزار",
  "میلیون",
  "میلیارد",
  "تریلیون",
  "کوادریلیون",
  "کویینتیلیون",
  "سکستیلیون",
];
const currentChars = (str) => {
  if (!str) {
    return;
  }

  str = str.replaceAll("‌", " ");
  str = str.replaceAll("  ", " ");

  for (let i = 0; i < motionsList.length; i += 1) {
    str = str.replaceAll(motionsList[i], "");
  }

  str = str.toLowerCase();
  str = str.replace(/\ي/g, "ی");
  str = str.replace(/\ك/g, "ک");
  str = str.replace(/(\ـ|\َ|\ِ|\ُ|\ً|\ٍ|\ٌ|\ْ|\ْ)/g, "");
  str = str.replace(/^\s+|^0-9+|^۰-۹|[^(آ-ی)(a-z)]+/g, "");
  for (const key in arabicLetterObj) {
    res = str.replaceAll(key, arabicLetterObj[key]);
  }

  return str.trim();
};
const arabicToPersian = (str) => {
  if (!str) {
    return;
  }

  for (const key in arabicLetterObj) {
    str = str.replaceAll(key, arabicLetterObj[key]);
  }
  for (let i = 0; i < motionsList.length; i += 1) {
    str = str.replaceAll(motionsList[i], "");
  }

  return str;
};
const numberToEnglish = (str) => {
  if (!str) {
    return;
  }
  for (let i = 0; i < 10; i += 1) {
    str = str
      .replaceAll(persianNumbersList[i], i)
      .replace(arabicNumbersList[i], i);
  }

  return str.trim();
};
const numberToWord_V2 = (value) => {
  try {
    eval(value);
  } catch {
    return "";
  }

  let delimiter, digit, i, iThree, numbers, parts, result, resultThree, three;

  if (typeof value !== "string") {
    value = value.toString();
  }

  parts = [
    "",
    "هزار",
    "میلیون",
    "میلیارد",
    "تریلیون",
    "کوادریلیون",
    "کویینتیلیون",
    "سکستیلیون",
  ];
  numbers = {
    0: [
      "",
      "صد",
      "دویست",
      "سیصد",
      "چهارصد",
      "پانصد",
      "ششصد",
      "هفتصد",
      "هشتصد",
      "نهصد",
    ],
    1: ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"],
    2: ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"],
    two: [
      "ده",
      "یازده",
      "دوازده",
      "سیزده",
      "چهارده",
      "پانزده",
      "شانزده",
      "هفده",
      "هجده",
      "نوزده",
    ],
    zero: "صفر",
  };
  delimiter = " و ";

  valueParts = value
    .split("")
    .reverse()
    .join("")
    .replace(/\d{3}(?=\d)/g, "$&,")
    .split("")
    .reverse()
    .join("")
    .split(",")
    .map(function (str) {
      return Array(4 - str.length).join("0") + str;
    });

  result = (function () {
    let _results;
    _results = [];
    for (iThree in valueParts) {
      three = valueParts[iThree];

      resultThree = (function () {
        let _i, _len, _results1;
        _results1 = [];

        for (i = _i = 0, _len = three.length; _i < _len; i = ++_i) {
          digit = three[i];
          if (i === 1 && digit === "1") {
            _results1.push(numbers.two[three[2]]);
          } else if (
            (i !== 2 || three[1] !== "1") &&
            numbers[i][digit] !== ""
          ) {
            _results1.push(numbers[i][digit]);
          } else {
            continue;
          }
        }

        return _results1;
      })();

      resultThree = resultThree.join(delimiter);
      let _result = resultThree
        ? resultThree + " " + parts[valueParts.length - parseInt(iThree) - 1]
        : resultThree;
      _results.push(_result);
    }
    return _results;
  })();

  result = result.filter(function (x) {
    return x.trim() !== "";
  });

  result = result.join(delimiter).trim();
  if (result === "") {
    result = numbers.zero;
  }

  return result;
};
const numberToWord_V1 = (value) => {
  let word = "";

  let countType = 1;
  const parse = (number) => {
    let mode3 = number % 1000;
    const newNumber = Math.floor(number / 1000);

    let mode2 = mode3 % 100;
    mode3 = Math.floor(mode3 / 100);
    let toWord;

    if (mode2 < 20) {
      toWord = one[mode2];
      word = `${toWord} ${word}`;
    } else {
      const mode1 = mode2 % 10;
      mode2 = Math.floor(mode2 / 10);
      if (mode1 !== 0) {
        toWord = one[mode1];
        word = `${toWord} ${word}`;
      }
      if (mode2 !== 0 && mode1 !== 0) {
        toWord = ten[mode2];
        word = `${toWord} و ${word}`;
      } else if (mode2 !== 0 && mode1 === 0) {
        toWord = ten[mode2];
        word = `${toWord} ${word}`;
      }
    }
    if (mode3 !== 0) {
      toWord = hundred[mode3];
      if (mode2 !== 0) {
        word = `${toWord} و ${word}`;
      } else {
        word = `${toWord} ${word}`;
      }
    }

    if (newNumber >= 1) {
      if (newNumber % 1000 !== 0) {
        word = `${type[countType]} و ${word} `;
      }
      countType += 1;
      return parse(newNumber);
    }
    word = word.replace("     ", " ");
    word = word.replace("    ", " ");
    word = word.replace("   ", " ");
    word = word.replace("  ", " ");
    if (word.substr(word.length - 3, 3) === " و ") {
      word = word.substr(0, word.length - 3);
    }
    return word;
  };
  parse(value);
};
const switchKey = (value) => {
  if (!value) {
    return;
  }
  let persianChar = [
      "ض",
      "ص",
      "ث",
      "ق",
      "ف",
      "غ",
      "ع",
      "ه",
      "خ",
      "ح",
      "ج",
      "چ",
      "ش",
      "س",
      "ی",
      "ب",
      "ل",
      "ا",
      "ت",
      "ن",
      "م",
      "ک",
      "گ",
      "ظ",
      "ط",
      "ز",
      "ر",
      "ذ",
      "د",
      "پ",
      "و",
      "؟",
      "ئ",
    ],
    englishChar = [
      "q",
      "w",
      "e",
      "r",
      "t",
      "y",
      "u",
      "i",
      "o",
      "p",
      "[",
      "]",
      "a",
      "s",
      "d",
      "f",
      "g",
      "h",
      "j",
      "k",
      "l",
      ";",
      "'",
      "z",
      "x",
      "c",
      "v",
      "b",
      "n",
      "m",
      ",",
      "?",
      "m",
    ];

  for (let i = 0, charsLen = persianChar.length; i < charsLen; i++) {
    value = value.replace(new RegExp(persianChar[i], "g"), englishChar[i]);
  }
  return value;
};
const halfSpace = (value) => {
  if (!value) {
    return;
  }

  let pattern;

  // Replace Zero-width non-joiner between persian MI.
  pattern = /((\s\u0645\u06CC)+( )+([\u0600-\u06EF]{1,}){1,})/g;
  value = value.replace(new RegExp(pattern), "$2\u200C$4");

  // Replace Zero-width non-joiner between perisan De-Yii.
  pattern = /(([\u0600-\u06EF]{1,})+( )+(ای|ایی|اند|ایم|اید|ام){1})/g;
  value = value.replace(new RegExp(pattern), "$2\u200C$4");

  return value;
};
const seperateNumber = (str) => {
  str = numberToEnglish(str);
  const number = (str + "").replaceAll(",", "").split("").reverse();
  let result = "";
  for (let i = 1; i <= number.length; i++) {
    if (i % 3 === 0) {
      number[i - 1] = `,${number[i - 1]}`;
    }
  }
  number.reverse().forEach((num) => (result += num));
  if (result.slice(0, 1) === ",") {
    result = result.slice(1);
  }
  return result;
};
const compareWord = (str1, str2) => {
  str1 = currentChars(str1);
  str1 = arabicToPersian(str1);
  str1 = numberToEnglish(str1);
  str2 = currentChars(str2);
  str2 = arabicToPersian(str2);
  str2 = numberToEnglish(str2);
  return str1 === str2;
};

module.exports = {
  currentChars,
  arabicToPersian,
  numberToEnglish,
  seperateNumber,
  numberToWord: numberToWord_V2,
  numberToWord_V2,
  numberToWord_V1,
  switchKey,
  halfSpace,
  compareWord,
};
